<template>
    <div class="bar">
        <controlbar-wrapper class="buttons">
            <icon-button v-if="!extWindow" icon="arrow-alt-left" size="2x" tabindex="-1"
                    @click="hideMessage" :title="$t('messageBar.backToList')"/>

            <icon-button icon="trash-alt" size="2x" v-if="rights.indexOf('t') !== -1" tabindex="-1"
                    @click="doDelete" :title="$t('messageBar.delete')"/>

            <icon-button icon="envelope" size="2x" @click="doMarkUnread" v-if="rights.indexOf('s') !== -1"
                    tabindex="-1" class="mq-mdplus"
                    :title="$t('messageBar.markUnread')"/>

            <icon-button icon="paper-plane" size="2x" v-if="rights.indexOf('o') !== -1" tabindex="-1"
                    @click="doCancelSend" :title="$t('messageBar.cancelsend')">
                <font-awesome-layers class="fa-2x">
                    <font-awesome-icon icon="paper-plane"></font-awesome-icon>
                    <font-awesome-icon icon="slash"></font-awesome-icon>
                </font-awesome-layers>
            </icon-button>
            <icon-button icon="redo" size="2x" v-if="rights.indexOf('o') !== -1" tabindex="-1"
                    @click="doResend" :title="$t('messageBar.resend')">
                <font-awesome-layers class="fa-2x">
                    <font-awesome-icon icon="paper-plane" transform="shrink-7"></font-awesome-icon>
                    <font-awesome-icon icon="redo"></font-awesome-icon>
                </font-awesome-layers>
            </icon-button>

            <span style="position:relative">
                <icon-button icon="folders" size="2x" ref="showMoveSelectorButton" tabindex="-1"
                        @click="showMoveSelector" class="mq-mdplus"
                        :title="$t('messageBar.moveFolder')"/>
                <move-selector v-if="moveSelectorShowed" :rights="rights"
                        v-click-outside="{ exclude: ['showMoveSelectorButton'], handler: 'hideMoveSelector'}"
                        @select="moveSelectorSelected"
                        @hide="hideMoveSelector"/>
            </span>

            <template v-if="rights.indexOf('o') === -1 && rights.indexOf('q') === -1">
                <icon-button icon="reply" size="2x" @click="$emit('message', 'reply')" tabindex="-1"
                        :title="$t('messageBar.reply')"/>
                <icon-button v-if="replyOptions.replyList"
                        @click="$emit('message', 'replyList')" tabindex="-1" :title="$t('messageBar.replyList')">
                    <font-awesome-layers class="fa-2x">
                        <font-awesome-icon icon="reply"
                                fixed-width transform="shrink-3 down-2 left-3"></font-awesome-icon>
                        <font-awesome-icon :icon="['far', 'list-alt']"
                                transform="shrink-3 up-2 right-3"></font-awesome-icon>
                    </font-awesome-layers>
                </icon-button>
                <icon-button icon="reply-all" size="2x" @click="$emit('message', 'replyAll')" tabindex="-1"
                        :title="$t('messageBar.replyAll')"/>
                <icon-button icon="share" size="2x" @click="$emit('message', 'forward')" tabindex="-1"
                        :title="$t('messageBar.forward')"/>
            </template>

            <drop-menu-button icon="bars" size="2x" tabindex="-1" v-if="moreMenu"
                    :aria="$t('messageBar.moreMenu')" :options="moreMenu" menuname="messageBar.menu"
                    @menu="$emit('menu', $event)"></drop-menu-button>
        </controlbar-wrapper>
    </div>
</template>

<script>
import IconButton from '@/components/iconButton';
import MoveSelector from '@/components/moveSelector';
import { FontAwesomeLayers, FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ControlbarWrapper from '@/components/controlbarWrapper';
import DropMenuButton from '@/components/DropMenuButton';

export default {
  name: 'messageControlBar',
  components: { DropMenuButton, IconButton, MoveSelector, FontAwesomeLayers, FontAwesomeIcon, ControlbarWrapper },
  data: function() {
    return {
      moveSelectorShowed: false
    };
  },
  props: {
    folderid: String,
    msgid: String,
    extWindow: Boolean,
    rights: String,
    replyOptions: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    doDelete() {
      this.$emit('deleteMessages', [this.msgUid]);
    },
    doMarkUnread() {
      this.$emit('updateMessages', { uids: [this.msgUid], newVal: { read: false } });
      this.hideMessage();
    },
    doCancelSend() {

    },
    doResend() {

    },
    hideMessage() {
      this.$router.push(`/${this.$route.params.foldertype}/${this.folderid}/` +
        `${this.$route.params.startpos}`);
    },
    showMoveSelector() {
      this.moveSelectorShowed = !this.moveSelectorShowed;
    },
    hideMoveSelector() {
      this.moveSelectorShowed = false;
    },
    moveSelectorSelected(evt) {
      this.hideMoveSelector();
      this.$emit('moveMessages', Object.assign(evt, { uids: [this.msgUid] }));
    }
  },
  computed: {
    msgUid() {
      return parseInt(this.msgid, 10);
    },
    moreMenu() {
      const size = this.$mqIs('sm') ? 'messageBar.menuSmall' : 'messageBar.menu';
      let menu = [
        { text: this.$t(`${size}.showSource`), value: 'showSource' },
        { text: this.$t(`${size}.addAutomaticRule`), value: 'addAutomaticRule' },
        { text: this.$t(`${size}.addManualRule`), value: 'addManualRule' },
        { text: this.$t(`${size}.blockSender`), value: 'blockSender' }
      ];
      if (this.$mqIs('sm')) {
        menu = [
          { text: this.$t(`${size}.markUnread`), value: 'markUnread' },
          { text: this.$t(`${size}.moveFolder`), value: 'moveFolder' },
          ...menu];
      }

      return menu;
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .bar {
        display: flex;
        height: 50px;
        padding: 10px 0 10px 0;
        border-top: 1px solid $gray-300;
        border-bottom: 1px solid $gray-300;
        font-size: $message-list-size;

        .buttons {
            flex: 1;
        }

        .closearrow {
            flex: 0 20px;
            padding-left: 10px;
        }
    }

</style>
